import { property, array, defaultVal, optional, } from 'class-converter';


export class AcquereurCP {
    @property('id', null, true) id = null;
    @property('success', null, true) success;
    @property('message', null, true) message;
    @property('acquereur', null, true) acquereur = "";
    @property('typeAcquereur', null, true) typeAcquereur = "";
    @property('numeroAcquereur', null, true) numeroAcquereur = "";
    @property('nom', null, true) nom = "";
    @property('prenom', null, true) prenom = "";
    @property('raisonSocialeFR', null, true) raisonSocialeFR = "";
    @property('id_refUsi', null, true) id_refUsi = null;
    @property('id_refExp', null, true) id_refExp = null;
    @property('numeroAutorisation', null, true) numeroAutorisation = null;
    @property('numeroAgrement', null, true) numeroAgrement = null;
}
export class CedantCP {
    @property('id', null, true) id;
    @property('success', null, true) success;
    @property('message', null, true) message;
    @property('cedant', null, true) cedant;
    @property('typeCedant', null, true) typeCedant;
    @property('numeroCedant', null, true) numeroCedant;
    @property('nom', null, true) nom;
    @property('prenom', null, true) prenom;
    @property('raisonSocialeFR', null, true) raisonSocialeFR;
    @property('id_refUsi', null, true) id_refUsi;
    @property('id_refExp', null, true) id_refExp;
    @property('numeroAutorisation', null, true) numeroAutorisation = null;
    @property('numeroAgrement', null, true) numeroAgrement = null;
}
export class RefEspece {
    @property('id', null, true) id;
    @property('code', null, true) code;
    @property('libelle', null, true) libelle;
    @property('codeCommun', null, true) codeCommun;
    @property('codeEspece', null, true) codeEspece;
}
export class RefTypeTransformation {
    @property('id', null, true) id;
    @property('code', null, true) code;
    @property('nom', null, true) nom;
}
export class SourceEspece {
    @property('id', null, true) id;
    @property('disponible', null, true) disponible;
    @property('quantite', null, true) quantiteCD;
    @property('quantite', null, true) quantite;
    @property('poidCD', null, true) poidCD;
    @property('typeTransformation', null, true) typeTransformation;
    @property('sourceDetail', null, true) sourceDetail;
    @property('nomNavire', null, true) nomNavire;
    @property('numeroLicence', null, true) numeroLicence;
    @property('listSource', null, true) listSource;
    @property('checked', null, true) checked;
    @property('armateurExiste', null, true) armateurExiste;
    @property('actif', null, true) actif;
    @property('bloquee', null, true) bloquee;
    @property('dateBloDeb', null, true) dateBloDeb;
    @property('typeSource', null, true) typeSource;
    @property('refTypeTransf', RefTypeTransformation) refTypeTransf;
    @property('id_refCessionPrd', null, true) id_refCessionPrd;
    @property('id_refSource', null, true) id_refSource;
    @property('rendementG', null, true) rendementG;
    @property('rendementT', null, true) rendementT;
    @property('id_refSourceEspeceCCSrc', null, true) id_refSourceEspeceCCSrc;
    @property('id_refSourceEspeceCPSrc', null, true) id_refSourceEspeceCPSrc;
    @property('id_refDeclaration', null, true) id_refDeclaration;
    @property('id_refSourceCP', null, true) id_refSourceCP;
    @property('refEspece', RefEspece) refEspece;
    @defaultVal(false) @property('selected', null, true) selected;
    @defaultVal(0) @optional() @property('rendementGH', null, true) rendementGH;
    @defaultVal(0) @optional() @property('rendementTH', null, true) rendementTH;
}

export class SourceCP {
    @property('id', null, true) id;
    @property('success', null, true) success;
    @property('message', null, true) message;
    @property('typeSource', null, true) typeSource = "";
    @property('codeSource', null, true) codeSource = "";
    @property('categoriePeche', null, true) categoriePeche = null;
    @property('id_refCessionPrdSrc', null, true) id_refCessionPrdSrc;
    @property('id_refCessionCapSrc', null, true) id_refCessionCapSrc;
    @property('id_refCessionPrd', null, true) id_refCessionPrd;
    @property('id_refCessionCap', null, true) id_refCessionCap;
    @property('id_RefTypeSource', null, true) id_RefTypeSource = "";
    @array() @property('childrenSrcEsp', SourceEspece) childrenSrcEsp = [];
    @array() @optional() @property('allChildrenSrcEsp', SourceEspece) allChildrenSrcEsp = [];
    @array() @optional() @property('sourceCPList') sourceCPList = [];
}
export default class CessionProduit {
    @property('id', null, true) id;
    @property('numeroCession', null, true) numeroCession;
    @property('numeroCessionComplet', null, true) numeroCessionComplet;
    @property('dateCession', null, true) dateCession;
    @defaultVal(new Date()) @property('dateSysteme', null, true) dateSysteme;
    @property('etat', null, true) etat;
    @property('categoriePeche', null, true) categoriePeche = null;
    @property('typeCedant', null, true) typeCedant;
    @property('typeAcquereur', null, true) typeAcquereur;
    @property('auditLabelDesc', null, true) auditLabelDesc;
    @optional() @property('entreposage') entreposage = false;
    @defaultVal(new AcquereurCP()) @property('acquereurCPDTO', AcquereurCP) acquereurCPDTO;
    @optional() @property('entrepotCPDTO', AcquereurCP) entrepotCPDTO;
    @defaultVal(new CedantCP()) @property('cedantCPDTO', CedantCP) cedantCPDTO;
    @array() @optional() @property('childrenSourceCP', SourceCP) childrenSourceCP;

}
export class SourceEspeceView {
    @property('quantite', null, true) quantite;
    @property('nomNavire', null, true) nomNavire;
    @property('refEspece', RefEspece) refEspece;
    @property('source', null, true) source;
    @property('disponible', null, true) disponible;
    @property('dc', null, true) dc;
    @property('poidCD', null, true) poidCD;
    @property('rendementG', null, true) rendementG;
    @property('rendementT', null, true) rendementT;
    @property('tranformation', null, true) transformation;
    @property('autreTrans', null, true) autreTrans;
    @property('id_refCessionCap', null, true) id_refCessionCap;
    @property('id_refSourceCC', null, true) id_refSourceCC;
    @property('id_refSourceEspeceCCSrc', null, true) id_refSourceEspeceCCSrc;
    @property('id_refSourceEspDCSrc', null, true) id_refSourceEspDCSrc;
    @property('id_refSourceEspETASrc', null, true) id_refSourceEspETASrc;
    @property('id_refDeclaration', null, true) id_refDeclaration;
    @property('actif', null, true) actif;
    @defaultVal(true) @property('selected', null, true) selected;
}
export class SourceCPView {

    @property('id', null, true) id;
    @property('cc', null, true) cc;
    @property('cp', null, true) cp;
    @property('codeSource', null, true) codeSource;
    @property('typeSource', null, true) typeSource;
    @array() @property('childrenSrcEsp', SourceEspeceView) childrenSrcEsp;
    @array() @optional() @property('allChildrenSrcEsp', SourceEspece) allChildrenSrcEsp = [];

}
export class CessionProduitView {
    @property('id', null, true) id;
    @property('numeroCessionComplet', null, true) numeroCessionComplet;
    @property('dateCession', null, true) dateCession;
    @property('dateSysteme', null, true) dateSysteme;
    @property('typeAcquereur', null, true) typeAcquereur;
    @property('loginAcquereur', null, true) loginAcquereur;
    @property('raisonSocialAcquereur', null, true) raisonSocialAcquereur;
    @property('prenomAcquereur', null, true) prenomAcquereur;
    @property('nomAcquereur', null, true) nomAcquereur;
    @optional() @property('entreposage') entreposage = false;
    @property('etat', null, true) etat;
    @property('acquereurCPDTO', AcquereurCP) acquereurCPDTO;
    @optional() @property('entrepotCPDTO', AcquereurCP) entrepotCPDTO;
    @property('cedantCPDTO', CedantCP) cedantCPDTO;
    @array() @property('childrenSourceCP', SourceCPView) childrenSourceCP;
}